import { useUserData } from "components/UserDataContext/UserDataContext";
import {
  API_BASE_URL
} from "configs/AppConfig";
import { getValidToken } from "auth/TokenRefresh";
import { jwtDecode } from "jwt-decode";
import { signOut } from "store/slices/authSlice";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
const userTimeZone = dayjs.tz.guess();
export const isValidToken = (token) => {
  if (token) {
    // A malformed value (e.g. the string "undefined" saved after a login response without a
    // token) makes jwtDecode throw — treat it as no token so the user is signed out instead.
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Current time in seconds
      return decodedToken.exp > currentTime;
    } catch {
      return false;
    }
  }
  return false;
};
export function useApiService() {
  const dispatch = useDispatch();
  const { setLoading, companyId, factoryId, users } = useUserData();
  const serviceFunction = async (endPoint, type, data = null, isBodyStringiy = false) => {
    const token = await getValidToken();
    if (token) {
      try {
        setLoading(true);
        const seperator = endPoint.includes("?") ? "&" : "?";
        const url = `${API_BASE_URL}/${endPoint}${seperator}CompanyId=${companyId}&FactoryId=${factoryId}&UserId=${users[0].id}&UserTimeZone=${userTimeZone}`;
        const body = isBodyStringiy ? data : JSON.stringify(data);
        const options = {
          method: type,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${token}`,
          },
          ...(type === "POST" && { body: body }),
        };
        const response = await fetch(url, options);
        setTimeout(() => {
          setLoading(false); // Delay state update by 1 second (1000ms)
        }, 1000);
        if(response.status == "401"){
          dispatch(signOut());
          return;
        }
        return response;
      } catch (error) {
        console.error("Error during API call:", error);
      } finally {
        setLoading(false);
      }
    } else {
      dispatch(signOut());
    }
  };

  return serviceFunction;
}
const withApiService = (WrappedComponent) => {
  return (props) => {
    const apiService = useApiService();
    return <WrappedComponent {...props} apiService={apiService} />;
  };
};

export default withApiService;
